<script setup>
import Header from "Admin/js/Mobile/Components/Common/Header.vue";
import Footer from "Admin/js/Mobile/Components/Common/Footer.vue";
import { provideMobileUser } from "Admin/js/Mobile/Composables/useMobileUser";
import { provideMobileWorkday } from "Admin/js/Mobile/Composables/useMobileWorkday";
import { provideMobileApp } from "Admin/js/Mobile/Composables/useMobileApp";
import { onMounted, computed, ref, watch } from "vue";
import WelcomePopupStaticContent from "Admin/js/Page/Mobile/Align/WelcomePopupStaticContent.vue";
import { useRoute } from "vue-router";
import { ROUTE_NAMES } from "Admin/js/Constants/routes";

const { isInitializing, initializeApp, notify, hideNotify } =
    provideMobileApp();
const {
    isLoadingUser,
    userState,
    userProfile,
    isRemoteSignup,
    fetchUserData,
    fetchUserState,
    fetchColorTheme,
    tourState,
} = provideMobileUser();
const { fetchWorkdayData } = provideMobileWorkday();
const { startTour, isTourActive } = tourState;
const route = useRoute();

const showWelcomePopup = ref(false);

const isIntiating = computed(() => {
    return isInitializing.value || isLoadingUser.value;
});

function getIsOwnerOrAdmin() {
    const { owner, admin } = userProfile.value?.permissions ?? {};
    return owner || admin;
}

function handleShowWelcomePopupDialog() {
    const isOwnerOrAdmin = getIsOwnerOrAdmin();

    if (
        !userState.value ||
        !isOwnerOrAdmin ||
        !isRemoteSignup.value ||
        isTourActive.value
    ) {
        return;
    }

    // showWelcomePopup.value = true;
}

function handleCloseWelcomePopupDialog() {
    showWelcomePopup.value = false;
    isRemoteSignup.value = false;
    startTour(0);
}
function handleCloseWelcomePopupDialogIconClick() {
    isRemoteSignup.value = false;
}
function handleGetHelpLinkClick() {
    showWelcomePopup.value = false;
}

watch(
    () => route.name,
    (newRouteName) => {
        const isOwnerOrAdmin = getIsOwnerOrAdmin();

        if (
            newRouteName === ROUTE_NAMES.MOBILE_ALIGN &&
            isRemoteSignup.value &&
            isOwnerOrAdmin &&
            !isTourActive.value
        ) {
            // showWelcomePopup.value = true;
        }
    },
);

onMounted(async () => {
    await fetchUserData();
    await fetchUserState();
    fetchColorTheme();
    fetchWorkdayData();
    initializeApp();
    handleShowWelcomePopupDialog();
});
</script>

<template>
    <div
        class="mobile_main_layout bg-section d-flex flex-column justify-space-between"
    >
        <Header />
        <div style="height: calc(100dvh - 8rem)">
            <KLoader v-if="isIntiating" />
            <RouterView v-else />
        </div>
        <Footer />
    </div>

    <!-- <KMobileDialog
        show-footer
        v-model="showWelcomePopup"
        title="Welcome to Kaamfu"
        :closeOnBackdrop="false"
        @onCloseIconClick="handleCloseWelcomePopupDialogIconClick"
    >
        <template #content>
            <WelcomePopupStaticContent @linkClick="handleGetHelpLinkClick" />
        </template>
        <template #footer>
            <div class="d-flex justify-end">
                <KButton
                    @click="handleCloseWelcomePopupDialog"
                    label="START TOUR"
                />
            </div>
        </template>
    </KMobileDialog> -->

    <v-snackbar
        v-model="notify.visible"
        :color="notify.type"
        :location="notify.location"
        :timeout="notify.timeout"
        @update:model-value="(ev) => !ev && hideNotify()"
    >
        <span style="color: #ffffff">
            {{ notify.message }}
        </span>
        <template v-slot:actions>
            <v-btn color="white" variant="text" @click="hideNotify">
                Close
            </v-btn>
        </template>
    </v-snackbar>
</template>
<style lang="scss">
.mobile_main_layout {
    height: 100dvh;
    font-family: "Inter", "Roboto", sans-serif;
}
</style>
